import { type MutationHookOptions, useMutation } from '@apollo/client';
import {
    MarkUserWidgetAsDisplayedDocument,
    type MarkUserWidgetAsDisplayedMutation,
    type MarkUserWidgetAsDisplayedMutationVariables,
} from './useUserDisplayedWidgetSuspense.monolith.generated';

export { MarkUserWidgetAsDisplayedDocument };

export const useMarkWidgetAsDisplayedMutation = (
    options?: MutationHookOptions<
        MarkUserWidgetAsDisplayedMutation,
        MarkUserWidgetAsDisplayedMutationVariables
    >,
) => {
    return useMutation(MarkUserWidgetAsDisplayedDocument, options);
};
